import client from '@/api/client';
import { BASE_URL } from '@/constants';
import { objectToQueryString } from '@/utils/sfaas_temp';

export default {
	async getCommCodes(codeType, plantCd) {
		try {
			const response = await client.get(`${BASE_URL}/cc/v1/plants/${plantCd}/commonCodes?commCdType=${codeType}`);
			return response?.data;
		} catch (error) {
			throw error.response?.data;
		}
	},
	async getList({ searchParams, currentPage, pageUnit }) {
		try {
			const queryStr = objectToQueryString({
				useYn: 'Y',
				currentPage,
				pageUnit
			});
			const response = await client.get(`${BASE_URL}/pqy/fcku/fwdCku/v1/lists${queryStr}`);
			return response?.data;
		} catch (error) {
			throw error.response?.data;
		}
	},
	async getDetailList({ searchParams, currentPage, pageUnit }) {
		try {
			const queryStr = objectToQueryString({
				custCd: searchParams.custCd,
				cpnyScn: '10',
				currentPage,
				pageUnit
			});
			const response = await client.get(`${BASE_URL}/pqy/fcku/fwdCkuCust/v1/lists${queryStr}`);
			return response?.data;
		} catch (error) {
			throw error.response?.data;
		}
	},
	async saveData({ custCd, cpnyScn }, { detailList }) {
		try {
			const pathVariables = `custCd/${custCd}`;
			const response = await client.post(`${BASE_URL}/pqy/fcku/fwdCkuCust/v1/status/2/${pathVariables}`, detailList);
			return response?.data;
		} catch (error) {
			throw error.response?.data;
		}
	},
	async fileDownload(params) {
		// 이미지 미리보기와 실제파일 다운로드에서 같이 사용하기 때문에 주의할것
		try {
			const response = await client.post(`${BASE_URL}/uploadForm/v1/downloadFile`, params, { responseType: 'blob' });
			return response;
		} catch (error) {
			throw error.response?.data;
		}
	}
};
